import theme from "@/styles/themes/theme";
import { css } from "@emotion/react";

export const styles = {
  cardlogo: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 24px;
    justify-content: center;
    gap: 16px;
  `,
  carddetalhe__link: css`
    text-decoration: none;
  `,
  carddetalhe__container: css`
    display: flex;
    width: 300;
  `,
  carddetalhe: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 24px;
    justify-content: center;
    gap: 16px;
    height: 900px;
  `,
  cardbilhete: css`
    display: flex;
    border-radius: 15px;
  `,
  carddetalhe__bilhete: css`
    display: flex;
    flex-direction: row;
    gap: 10px;
  `,
  carddetalhe__logo: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35px;
    width: 50px;
    border-radius: 5px;
    background-color: ${theme.palette.grey[400]};
  `
};
